/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import { slugify } from "helpers";
import LinkButton from "components/LinkButton";
import { InCartButton, AddToCartButton } from "./searchResultButtons";
import PriceFormat from "../PriceFormat";

export const SearchResultNormalPricing = ({
  salePrice,
  retailPrice,
  found,
  added,
  onCartAdd,
  sku,
  id,
  setAdded
}) => {
  return (
    <div className="products__result-cost" id="searchResultNormalPricing">
      {salePrice && salePrice <= retailPrice ? (
        <div>
          <div
            className="products__result-price products__result-price--regular"
            id="searchResultNormalPricing--regular-pricing-container"
          >
            <span id="searchResultNormalPricing--regular-price">
              Regular Price:
            </span>
            <span>
              <PriceFormat id="priceFormat" value={retailPrice} />
            </span>
          </div>
          <div
            className="products__result-price products__result-price--sale"
            id="searchResultNormalPricing--sale-pricing-container"
          >
            <span id="searchResultNormalPricing--sale-price">Sale Price</span>
            <span>
              <PriceFormat id="priceFormat" value={salePrice} />
            </span>
          </div>
        </div>
      ) : retailPrice === 0 ? (
        <div
          className="products__result-price"
          id="searchResultNormalPricing--free-price-container"
        >
          <span id="searchResultNormalPricing--free"> Free </span>
        </div>
      ) : (
        <div className="products__result-price">
          <span id="searchResultNormalPricing--retail-price-container">
            <PriceFormat id="priceFormat" value={retailPrice} />
          </span>
        </div>
      )}
      {found || added ? (
        <InCartButton id="inCartButton" />
      ) : (
        <AddToCartButton
          onCartAdd={onCartAdd}
          sku={sku}
          id={id}
          price={retailPrice}
          setAdded={setAdded}
        />
      )}
    </div>
  );
};

SearchResultNormalPricing.propTypes = {
  salePrice: PropTypes.number,
  retailPrice: PropTypes.number,
  found: PropTypes.bool,
  added: PropTypes.bool,
  onCartAdd: PropTypes.func,
  setAdded: PropTypes.func,
  sku: PropTypes.string,
  id: PropTypes.number
};

SearchResultNormalPricing.defaultProps = {
  salePrice: null,
  retailPrice: null,
  found: false,
  added: false,
  onCartAdd: undefined,
  setAdded: undefined,
  sku: undefined,
  id: null
};

export const SearchResultEnterprisePricing = ({
  productName,
  sku,
  retailPrice,
  salePrice,
  showPrice
}) => {
  return showPrice === false ? (
    <>
      <div
        className="products__result-quote"
        id="searchResultEnterprisePricing--showPriceFalse"
      >
        <div
          className="products__result-price products__result-price--team"
          id="searchResultEnterprisePricing--licenseInfo"
        >
          This product cannot be purchased as an individual&nbsp;license.
        </div>
        {productName !== undefined && (
          <LinkButton
            className="btn btn-sm btn-block btn-outline-primary products__result-cart"
            id="searchResultEnterprisePricing--learn-more-link"
            to={`/products/${slugify(productName)}-${sku}`}
          >
            Learn More
          </LinkButton>
        )}
      </div>
    </>
  ) : (
    <div
      className="products__result-quote"
      id="searchResultEnterprisePricing--showPriceTrue"
    >
      <div
        className="enterpriseProducts__result-price products__result-price--team"
        id="searchResultEnterprisePricing--pricing-container"
      >
        <span id="searchResultEnterprisePricing--pricing-starting-at">
          Pricing Starting At
        </span>
        {salePrice && salePrice <= retailPrice ? (
          <>
            <div
              className="enterpriseProducts__result-price enterpriseProducts__result-price--regular"
              id="searchResultEnterprisePricing--regular-pricing-container"
            >
              <span id="searchResultEnterprisePricing--regular-price">
                Regular Price:
              </span>
              <span>
                <PriceFormat id="priceFormat" value={retailPrice} />
              </span>
            </div>
            <div
              className="enterpriseProducts__result-price enterpriseProducts__result-price--sale"
              id="searchResultEnterprisePricing--sale-pricing-container"
            >
              <span id="searchResultEnterprisePricing--sale-price">
                Sale Price
              </span>
              <span>
                <PriceFormat id="priceFormat" value={salePrice} />
              </span>
            </div>
          </>
        ) : (
          <span>
            <PriceFormat id="priceFormat" value={retailPrice} />
          </span>
        )}
        <span id="searchResultEnterprisePricing--per-license">per license</span>
      </div>
      {productName !== undefined && (
        <LinkButton
          className="btn btn-sm btn-block btn-outline-primary products__result-cart"
          id="searchResultsEnterprisePricing--learn-more-button"
          to={`/products/${slugify(productName)}-${sku}`}
        >
          Learn More
        </LinkButton>
      )}
    </div>
  );
};

SearchResultEnterprisePricing.propTypes = {
  productName: PropTypes.string,
  sku: PropTypes.string,
  retailPrice: PropTypes.number,
  salePrice: PropTypes.number,
  showPrice: PropTypes.bool
};

SearchResultEnterprisePricing.defaultProps = {
  productName: undefined,
  sku: undefined,
  salePrice: undefined,
  retailPrice: undefined,
  showPrice: undefined
};
